// Placeholder page for the China-warehouses sidebar entry (#698).
//
// Mounts under `/warehouses-china` behind `warehousesChina.read`. The
// real China-warehouses directory ships in a later phase; this surface
// only proves the route + permission gate work end-to-end and reuses
// the shared `Placeholder` shell which derives its H1 from the active
// menu match (`nav.items.warehousesChina`).
import { Placeholder } from '../../../shell/Placeholder.js';

export function WarehousesChinaPlaceholderPage() {
  return <Placeholder />;
}
